export enum AuthorizedApps {
    Builk = "builk",
    Jubili = "jubili",
    Kwanjai = "kwanjai",
    Intake = "intake"
}
